import { active } from "@api/stores/warehouses/active/path";
import { batches } from "@api/stores/warehouses/batches/path";
import { bulkAssignUsers } from "@api/stores/warehouses/bulkAssignUsers/path";
import { circulationEvents } from "@api/stores/warehouses/circulationEvents/path";
import { deactive } from "@api/stores/warehouses/deactive/path";
import { enterUnits } from "@api/stores/warehouses/enterUnits/path";
import { productBatchLocations } from "@api/stores/warehouses/productBatchLocations/path";
import { products } from "@api/stores/warehouses/products/path";
import { returnUnitsFromScraps } from "@api/stores/warehouses/returnUnitsFromScraps/path";
import { scrapUnits } from "@api/stores/warehouses/scrapUnits/path";
import { shelves } from "@api/stores/warehouses/shelves/path";
import { stats } from "@api/stores/warehouses/stats/path";
import { transferUnits } from "@api/stores/warehouses/transferUnits/path";
import { unassignUser } from "@api/stores/warehouses/unassignUser/path";
import { withdrawUnits } from "@api/stores/warehouses/withdrawUnits/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/`;
const pathById = `${pathBase}:warehouseId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const warehouses = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
  stats,
  bulkAssignUsers,
  unassignUser,
  shelves,
  products,
  batches,
  productBatchLocations,
  circulationEvents,
  withdrawUnits,
  enterUnits,
  transferUnits,
  scrapUnits,
  returnUnitsFromScraps,
};
